import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {UtilsService} from "../../../../core/utils/utils.service";
import {BesoinsService} from "../../../../core/services/gestion-commandes/besoins.service";
import {Subscription} from "rxjs";
import {UniteDeProductionDTO} from "../../../../core/dtos/unite-de-production-dto";
import {
  DATEPICKER_FR,
  HELP_FOLDERS,
  MSG_KEY,
  MSG_SEVERITY,
  TYPE_LIST_UDP,
  TYPE_UNITE_DE_MESURE,
  UI_COLORS
} from "../../../../core/constants";
import {ProduitDeclinaisonService} from "../../../../core/services/entities/produit-declinaison.service";
import {UnitesDeProductionService} from "../../../../core/services/entities/unites-de-production.service";
import {ResponseWrapper} from "../../../../core/suppliers/wrappers/response-wrapper";
import {CatalogueAchatDTO} from "../../../../core/dtos/catalogue-achat-dto";
import {UniteDeProduction__SecteurFournisseurDTO} from "../../../../core/dtos/unite-de-production__secteur-fournisseur-dto";
import {UpdateGacaViewModel} from "../../../../shared/article/grille-remplacer-article/grille-remplacer-article.component";
import {GroupeAchatCaViewModel} from "../../../../core/models/gestion-produits/catalogue-achat/groupe-achat-ca-view.model";
import {CommandeDenreeModel} from "../../../../core/models/gestion-commande-fournisseur/commande-denree-model";
import {CommandesService} from "../../../../core/services/gestion-commandes/commandes.service";
import {find as _find} from 'lodash'
import {LotMarchePdLumpCaDto} from "../../../../core/dtos/gerstion-marche/lot-marche-pd-lump-ca-dto";
import {DATAGRID_ROW_TYPES} from "../../../../core/services/technique/devextreme.service";
import {SaveCommandeDenreeModel} from "../../../../core/models/gestion-commande-fournisseur/save-commande-denree-model";
import {DxDataGridComponent, DxDateBoxComponent} from "devextreme-angular";
import {ReglePrefereeCommandeFournisseurEnum} from "../../../../core/enums/regle-preferee-commande-fournisseur-enum";
import {confirm} from "devextreme/ui/dialog";
import {FournisseurDTO} from "../../../../core/dtos/fournisseur-d-t-o";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {InternationalizationService} from "../../../../core/services/i8n/i8n.service";
import {DenreeQuantiteModel} from "../../../../core/models/gestion-commande-fournisseur/denree-quantite-model";
import {DataCalculFraisDePortCommandeDenreeModel} from "../../../../core/models/gestion-commande-fournisseur/data-calcul-frais-de-port-commande-denree-model";

@Component({
  selector: 'yo-create-proposition-denree',
  templateUrl: './create-proposition-denree.component.html',
  styleUrls: ['./create-proposition-denree.component.scss']
})
export class CreatePropositionDenreeComponent implements OnInit, OnDestroy {

  @ViewChild('gridDenreeSelected') grid: DxDataGridComponent;
  @ViewChild('datebox') dateBox: DxDateBoxComponent;

  displayDialog: boolean = false;
  fullScreen: boolean = true;

  uniteDeProductionList: UniteDeProductionDTO[] = [];
  uniteDeProductionSelected: UniteDeProductionDTO;
  udpSfPrefereList: UniteDeProduction__SecteurFournisseurDTO[] = [];

  commandeDenreeList: CommandeDenreeModel[] = [];
  denreeQuantityList: DenreeQuantiteModel[] = [];

  optionScenarioArticle: any[] = [];
  scenarioArticleSelected: any;

  minDate: Date = new Date();
  dateSelected: Date = new Date();
  fr = DATEPICKER_FR;
  TYPE_UNITE_DE_MESURE = TYPE_UNITE_DE_MESURE;

  subOpenDialog: Subscription;
  subProduitDeclinaisonListPropCommande: Subscription;

  dropDownOptions = {width: 750};
  articlesDisponibles: CatalogueAchatDTO[] = [];
  selectedGacaViewModel: GroupeAchatCaViewModel;

  pathFile: string = HELP_FOLDERS.COMMANDES_FOURNISSEURS + '/proposition-commande-denree';

  displayDeliveryDateError: boolean = false;

  constructor(public utils: UtilsService,
              private besoinSvc: BesoinsService,
              private commandesSvc: CommandesService,
              private produitDeclinaisonSvc: ProduitDeclinaisonService,
              private uniteDeProductionSvc: UnitesDeProductionService,
              private toastSvc: ToastService,
              private i8nSvc: InternationalizationService) {
  }

  ngOnInit() {
    this.subscriptionOpenDialog();
    this.subscriptionProduitDeclinaisonListPropCommande();
    this.initData();
    this.initDataOptionsScenario();
  }

  ngOnDestroy() {
    this.utils.unsubscribe(this.subOpenDialog);
    this.utils.unsubscribe(this.subProduitDeclinaisonListPropCommande);
  }

  subscriptionOpenDialog = (): void => {
    this.subOpenDialog = this.besoinSvc.openPropositionDialogDenree$.subscribe(data => {
      this.displayDialog = true;
    })
  }

  subscriptionProduitDeclinaisonListPropCommande = (): void => {
    this.subProduitDeclinaisonListPropCommande = this.produitDeclinaisonSvc.produitDeclinaisonListPropCommande$.subscribe(data => {
      data.map(item => {
        let denreeQuantityModel: DenreeQuantiteModel = this.denreeQuantityList.find(d => d.idProduitDeclinaison == item.produitArticle.produitDeclinaison.id);
        if (denreeQuantityModel) {
          this.denreeQuantityList.map(d => {
            if (d.idProduitDeclinaison == item.produitArticle.produitDeclinaison.id) d.quantiteUT += item.quantite;
          })
          this.commandeDenreeList.map(c => {
            if (c.idProduitDeclinaison == item.produitArticle.produitDeclinaison.id) c.quantiteUT += item.quantite;
          })
        } else {
          denreeQuantityModel = new DenreeQuantiteModel();
          denreeQuantityModel.idProduitDeclinaison = item.produitArticle.produitDeclinaison.id;
          denreeQuantityModel.quantiteUT = item.quantite;
          this.denreeQuantityList.push(denreeQuantityModel);
        }
      })
      this.commandesSvc.getPropositionCommandeForCreationModeDenree(this.denreeQuantityList, this.uniteDeProductionSelected.id,
        this.dateSelected, this.scenarioArticleSelected.value).subscribe((result: ResponseWrapper<any>) => {
        const res: any = result.one;
        if (res.results) {
          if (this.commandeDenreeList.length) {
            this.commandeDenreeList = res.results.map(r => {
              const currentOrder: CommandeDenreeModel = this.commandeDenreeList.find(cmd => cmd.idProduitDeclinaison === r.idProduitDeclinaison);
              if (currentOrder) {
                r.quantiteUC = currentOrder.quantiteUC;
                r.quantiteUT = currentOrder.quantiteUT;
                r.isQuantiteUCRonded = currentOrder.isQuantiteUCRonded;
              }
              return r;
            });
          } else {
            this.commandeDenreeList = res.results;
          }
        }
        this.grid.instance.refresh();
        if (res.foodstuffsWithoutItemPurchased && res.foodstuffsWithoutItemPurchased.length && res.codeError) {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, this.i8nSvc.getLabelFromCode(res.codeError, res.foodstuffsWithoutItemPurchased));
        }
      });
    });
  }

  closeDialog = (): void => {
    this.commandeDenreeList = [];
    this.denreeQuantityList = [];
    this.dateSelected = new Date();
    this.initData();
    this.initDataOptionsScenario();
    this.displayDialog = false;
  }

  initData = (): void => {
    // Unite de production
    this.uniteDeProductionSvc.getUniteDeProductionlist(TYPE_LIST_UDP.OnlyLocal).subscribe((response: ResponseWrapper<UniteDeProductionDTO>) => {
      this.uniteDeProductionList = response.resultList
      if (this.uniteDeProductionList && this.uniteDeProductionList.length) {
        this.uniteDeProductionSelected = this.uniteDeProductionList[0];
        this.udpSfPrefereList = this.uniteDeProductionList[0].uniteDeProduction__secteurFournisseurList;
      }
    });
  }

  initDataOptionsScenario = (): void => {
    this.optionScenarioArticle.push({
      key: "Article préféré",
      value: ReglePrefereeCommandeFournisseurEnum.ARTICLE_PREFEREE
    });
    this.optionScenarioArticle.push({
      key: "Article le moins cher",
      value: ReglePrefereeCommandeFournisseurEnum.ARTICLE_LE_MOINS_CHER
    });
    this.optionScenarioArticle.push({
      key: "Filiales préférées (non géré à l'heure actuelle)",
      value: ReglePrefereeCommandeFournisseurEnum.FILIALE_PREFEREE
    });
    this.optionScenarioArticle.push({
      key: "Marchés - article avec ordre",
      value: ReglePrefereeCommandeFournisseurEnum.MARCHE_ARTICLE_AVEC_ORDRE
    });
    this.optionScenarioArticle.push({
      key: "Marchés - article le moins cher",
      value: ReglePrefereeCommandeFournisseurEnum.MARCHE_ARTICLE_LE_MOINS_CHER
    });
    this.scenarioArticleSelected = {
      key: "Article préféré",
      value: ReglePrefereeCommandeFournisseurEnum.ARTICLE_PREFEREE
    };
  }

  getProviderLabel = (feed: CommandeDenreeModel): string => {
    const gacaSelected: GroupeAchatCaViewModel = feed.gacaSelected;
    const idCatalogueAchat: number = gacaSelected ? gacaSelected.idCatalogueAchat : 0;
    const caList: CatalogueAchatDTO[] = feed.catalogueAchatList;
    if (idCatalogueAchat && caList && caList.length) {
      const caFound: CatalogueAchatDTO = caList.find(ca => ca.id === idCatalogueAchat);
      return caFound && caFound.fournisseur ? caFound.fournisseur.libelle : 'Non renseigné';
    }
    return 'Non renseigné';
  }

  onChangeScenarioArticle = (event): void => {
    this.reloadCommandeDenreeList();
  }

  checkBeforeSavePropositionList = (): void => {
    if (!this.commandeDenreeList || !this.commandeDenreeList.length) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, 'Veuillez ajouter une ou plusieurs denrée(s) avant de poursuivre');
    } else {
      if (this.commandeDenreeList.filter(item => item.quantiteUT === 0).length) {
        let result = confirm("Certaines denrées ont une quantité à zéro et ne seront pas pris en compte, souhaitez-vous continuer ?", "Demande de confirmation");
        result.then((dialogResult) => {
          if (dialogResult) this.generatePropositionList()
        });
      } else {
        this.generatePropositionList();
      }
    }
  }

  removeFeed = (feed: CommandeDenreeModel): void => {
    this.commandeDenreeList = this.commandeDenreeList.filter(cmd => cmd.idProduitDeclinaison !== feed.idProduitDeclinaison);
    this.denreeQuantityList = this.denreeQuantityList.filter(denree => denree.idProduitDeclinaison !== feed.idProduitDeclinaison);
    this.grid.instance.refresh();
  }

  generatePropositionList = (): void => {
    const saveCommandeModeDenreeList: SaveCommandeDenreeModel[] = this.getSaveCommandeModeDenree();

    this.commandesSvc.saveBonCfModeDenree(this.uniteDeProductionSelected.id, this.dateSelected, saveCommandeModeDenreeList)
      .subscribe((data: ResponseWrapper<any>) => {
        if (data.resultList.length === 0) {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, 'Enregistrement effectué avec succès');
          this.closeDialog();
          this.commandesSvc.announceRefreshPropositionCommandeGrid();
        } else {
          this.commandesSvc.announcePossibleDeliveryDates(data.resultList);
          this.displayDeliveryDateError = true;
        }
      });
  }

  private getSaveCommandeModeDenree = (): SaveCommandeDenreeModel[] => {
    let saveCommandeModeDenreeList: SaveCommandeDenreeModel[] = [];
    this.commandeDenreeList.forEach(item => {
      if (item.quantiteUC > 0) {
        let scdm: SaveCommandeDenreeModel = new SaveCommandeDenreeModel();
        scdm.quantiteUC = item.quantiteUC;
        scdm.quantiteUT = item.quantiteUT;
        scdm.idProduitDeclinaison = item.idProduitDeclinaison;
        scdm.libelleProduitDeclinaison = item.libelleProduitDeclinaison;
        scdm.idGroupeAchat_CatalogueAchat = item.gacaSelected.id;
        scdm.dateLivraisonPossible = item.dateLivraisonPossible;
        scdm.idFournisseur = item.catalogueAchatList.find(ca => ca.id === item.gacaSelected.idCatalogueAchat).fournisseur.id;
        saveCommandeModeDenreeList.push(scdm);
      }
    });
    return saveCommandeModeDenreeList;
  }

  private getDataCalculFraisPortCommandeModeDenree = (): DataCalculFraisDePortCommandeDenreeModel[] => {
    let datas: DataCalculFraisDePortCommandeDenreeModel[] = [];
    this.commandeDenreeList.forEach(item => {
      if (item.quantiteUC > 0) {
        let data: DataCalculFraisDePortCommandeDenreeModel = new DataCalculFraisDePortCommandeDenreeModel();
        data.quantiteUC = item.quantiteUC;
        data.idGroupeAchat_CatalogueAchat = item.gacaSelected?.id;
        data.dateLivraisonPossible = item.dateLivraisonPossible ? item.dateLivraisonPossible : this.dateSelected;
        data.idCatalogueAchat = item.gacaSelected?.idCatalogueAchat;
        data.idFournisseur = item.catalogueAchatList.find(ca => ca.id === item.gacaSelected.idCatalogueAchat)?.fournisseur?.id;
        data.ratioUC = item.catalogueAchatList.find(ca => ca.id === item.gacaSelected.idCatalogueAchat)?.ratioUniteCommandeUniteBase;
        data.idUdp = this.uniteDeProductionSelected.id;

        datas.push(data);
      }
    });
    return datas;
  }

  isDisabledSaveBtn = (): boolean => {
    return this.commandeDenreeList.length < 0;
  }

  help = (): void => {
    return undefined;
  }

  openAjoutDenree = (): void => {
    this.besoinSvc.announceOpenAjoutDenreePropositionCommande(this.uniteDeProductionSelected, this.dateSelected);
  }

  updatePrixUnitaireCommande = (component: any, event: UpdateGacaViewModel, cell: CommandeDenreeModel): void => {
    cell.catalogueAchatList.forEach(ca => {
      ca.groupeAchatCaList.forEach(gaca => {
        if (gaca.id === event.idGaca) {
          cell.gacaSelected = gaca;
          cell.libelleArticleSelected = ca.produitArticleLibelle;
        }
      });
    });
    component.close();
  }

  onChangeUniteDeProduction = (event: any): void => {
    if (event && event.value && event.value.uniteDeProduction__secteurFournisseurList) {
      this.udpSfPrefereList = event.value.uniteDeProduction__secteurFournisseurList;
    }
    if (this.commandeDenreeList && this.commandeDenreeList.length) {
      this.commandeDenreeList = [];
      this.denreeQuantityList = [];
    }
  }

  reloadCommandeDenreeList = (): void => {
    if (!this.uniteDeProductionSelected.id || !this.commandeDenreeList || !this.commandeDenreeList.length) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, 'Veuillez ajouter une ou plusieurs denrée(s) avant de changer le scénario');
      return;
    }
    if (this.scenarioArticleSelected.value === ReglePrefereeCommandeFournisseurEnum.FILIALE_PREFEREE) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, 'Scénario non fonctionnel');
      return;
    }
    this.commandesSvc.getPropositionCommandeForCreationModeDenree(this.denreeQuantityList, this.uniteDeProductionSelected.id,
      this.dateSelected, this.scenarioArticleSelected.value).subscribe((result: any) => {
      result.one.results.forEach(item => {
        const qte: number = this.findQuantiteUTUnSaved(result.one.results, item.idProduitDeclinaison);
        if (qte !== null) item.quantiteUT = qte;
      });
      this.commandeDenreeList = result.one.results;
    });
  }

  findQuantiteUTUnSaved = (commandeDenreeList: CommandeDenreeModel[], idProduitDeclinaison: number): number => {
    let cmd: CommandeDenreeModel = commandeDenreeList.find(commandeDenree => commandeDenree.idProduitDeclinaison === idProduitDeclinaison);
    return cmd ? cmd.quantiteUT : null;
  }

  getUniteDeMesureAbrevation = (cell: CommandeDenreeModel, typeUniteDeMesure: TYPE_UNITE_DE_MESURE): string => {
    if (!this.utils.isNullOrEmpty(cell)) {
      const ca: CatalogueAchatDTO = _find(cell.catalogueAchatList, ['id', cell.gacaSelected.idCatalogueAchat]);
      if (!this.utils.isNullOrEmpty(ca)) {
        switch (typeUniteDeMesure) {
          case TYPE_UNITE_DE_MESURE.uniteDeStockage :
            return ca.uniteDeStockage.abreviation;
          case TYPE_UNITE_DE_MESURE.uniteDeCommande :
            return ca.uniteDeCommande.abreviation;
          case TYPE_UNITE_DE_MESURE.uniteTechnique :
            return ca.uniteTechnique.abreviation;
          case TYPE_UNITE_DE_MESURE.uniteDeFacturation :
            return ca.uniteDeFacturation.abreviation;
        }
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getUniteDeMesureLibelle = (cell: CommandeDenreeModel, typeUniteDeMesure: TYPE_UNITE_DE_MESURE): string => {
    if (!this.utils.isNullOrEmpty(cell)) {
      const ca: CatalogueAchatDTO = _find(cell.catalogueAchatList, ['id', cell.gacaSelected.idCatalogueAchat]);
      if (!this.utils.isNullOrEmpty(ca)) {
        switch (typeUniteDeMesure) {
          case TYPE_UNITE_DE_MESURE.uniteDeStockage :
            return ca.uniteDeStockage.libelle;
          case TYPE_UNITE_DE_MESURE.uniteDeCommande :
            return ca.uniteDeCommande.libelle;
          case TYPE_UNITE_DE_MESURE.uniteTechnique :
            return ca.uniteTechnique.libelle;
          case TYPE_UNITE_DE_MESURE.uniteDeFacturation :
            return ca.uniteDeFacturation.libelle;
        }
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getQuantiteUTFromUC = (cell: CommandeDenreeModel): number => {
    if (!this.utils.isNullOrEmpty(cell)) {
      const ca: CatalogueAchatDTO = _find(cell.catalogueAchatList, ['id', cell.gacaSelected.idCatalogueAchat]);
      return Math.ceil(this.utils.convertQuantiteUdm1ToQuantiteUdm2(cell.quantiteUC, ca.ratioUniteCommandeUniteBase, ca.ratioUniteTechnique));
    }
  }

  getQuantiteUFFromUT = (cell: CommandeDenreeModel): number => {
    if (!this.utils.isNullOrEmpty(cell)) {
      const ca: CatalogueAchatDTO = _find(cell.catalogueAchatList, ['id', cell.gacaSelected.idCatalogueAchat]);
      const qteUTArrondie: number = this.getQuantiteUTFromUC(cell);
      return this.utils.convertQuantiteUdm1ToQuantiteUdm2(qteUTArrondie, ca.ratioUniteTechnique, ca.ratioUniteFacturationUniteBase);
    }
  }

  getQuantiteUCFromUT = (cell: CommandeDenreeModel): number => {
    if (!this.utils.isNullOrEmpty(cell)) {
      const ca: CatalogueAchatDTO = _find(cell.catalogueAchatList, ['id', cell.gacaSelected.idCatalogueAchat]);
      cell.quantiteUC = Math.ceil(this.utils.convertQuantiteUdm1ToQuantiteUdm2(cell.quantiteUT, ca.ratioUniteTechnique, ca.ratioUniteCommandeUniteBase));
      // Test si il y a eu un arrondi par rapport a la valeur brut
      cell.isQuantiteUCRonded = cell.quantiteUC !== this.utils.convertQuantiteUdm1ToQuantiteUdm2(cell.quantiteUT, ca.ratioUniteTechnique, ca.ratioUniteCommandeUniteBase);
      return cell.quantiteUC;
    }
  }

  getLmPdUpCa = (cell: CommandeDenreeModel): LotMarchePdLumpCaDto => {
    const ca: CatalogueAchatDTO = _find(cell.catalogueAchatList, ['id', cell.gacaSelected.idCatalogueAchat]);
    if (!this.utils.isNullOrEmpty(ca)) {
      return ca.lmPdUpCa;
    }
  }

  onCellPrepared = (event: any): void => {
    // si cell est un header
    if (event.rowType === DATAGRID_ROW_TYPES.HEADER) {
      // si colonne editable
      if (event.column.allowEditing) {
        event.cellElement.style.backgroundColor = UI_COLORS.EDITABLE;
      }
    } else {
      if (event.column.dataField === 'dateLivraisonPossible' && event.data.dateLivraisonPossible > this.dateSelected) {
        event.cellElement.style.backgroundColor = UI_COLORS.MODIFICATION_MANUELLE;
      }
      if (event.column.dataField === 'quantiteUC' && event.data.isQuantiteUCRonded) {
        event.cellElement.style.backgroundColor = UI_COLORS.INFO;
      }
    }
  }

  getQuantiteUCTooltip = (cell: CommandeDenreeModel): string => {
    if (cell.isQuantiteUCRonded) {
      return `La valeur a été arrondie au supérieure :
      ${cell.quantiteUC} ${this.getUniteDeMesureAbrevation(cell, TYPE_UNITE_DE_MESURE.uniteDeCommande)}  vaut  ${this.getQuantiteUTFromUC(cell)} ${this.getUniteDeMesureAbrevation(cell, TYPE_UNITE_DE_MESURE.uniteTechnique)}'.`;
    }
  }

  toggleFullScreen = (): void => {
    this.fullScreen = !this.fullScreen;
  }

  changeDateLivraisonMax = ($event: any) => {
    this.dateSelected = $event.value;

    this.commandeDenreeList.forEach(commandeDenree => {
      const fournisseur: FournisseurDTO = commandeDenree.catalogueAchatList.filter(item => item.id === commandeDenree.gacaSelected.idCatalogueAchat)[0].fournisseur;
      this.commandesSvc
        .calculateDateLivraisonPossible(this.uniteDeProductionSelected.id, $event.value, fournisseur.id, commandeDenree.idProduitDeclinaison)
        .subscribe(result => commandeDenree.dateLivraisonPossible = result.one);
    });

    if(this.commandeDenreeList.length) this.reloadCommandeDenreeList();
  };

  calculerFraisDePort = () => {
    const datas: DataCalculFraisDePortCommandeDenreeModel[] = this.getDataCalculFraisPortCommandeModeDenree();
    this.commandesSvc.calculerFraisDePortBonCf(datas)
      .subscribe(result => this.commandesSvc.announceFraisDePort(result.resultList));
  }

  showUniteFacturationLibelle = (cell: CommandeDenreeModel) =>
    cell.catalogueAchatList.filter(item => item.id === cell.gacaSelected.idCatalogueAchat)[0].uniteDeFacturation?.libelle;

  showPrixTotal = (cell: CommandeDenreeModel) => this.utils.roundTo((cell.quantiteUC * cell.gacaSelected.prixUC), 4);

  onRowUpdating = ($event: any) => {
    this.denreeQuantityList.map(item => {
      if(item.idProduitDeclinaison === $event.key && $event.newData.quantiteUT) item.quantiteUT = $event.newData.quantiteUT;
    })
  };
}
